import { useMemo } from "react";
import { useFilters } from "core/features/filters/store";
import { useRelatorioAnaliticoList, useRelatorioGraficoList } from "../../../hooks/useRelatorio";
import useRelatorioContext from "../../../hooks/useRelatorioContext";

export function useGetRelatorios() {
    const queryParams = useRelatorioContext((s) => s.queryParams);
    const setQueryParams = useRelatorioContext((s) => s.setQueryParams);
    const unidadeId = useFilters((s) => s.filters.unidade?.id);
    const safraId = useFilters((s) => s.filters.safra?.id);
    const safraPeriodo = useFilters((s) => s.filters.filtersAdvanced?.safraPeriodo);

    const query = useMemo(
        () => ({
            ...queryParams,
            UnidadeId: unidadeId,
            SafraId: safraId,
            SafraPeriodoIds: safraPeriodo,
        }),
        [queryParams, unidadeId, safraId, safraPeriodo]
    );

    const { data: listTalhoes, isLoading, isFetching } = useRelatorioAnaliticoList(query);

    return {
        listRelatorios: listTalhoes,
        setQueryParams,
        relatorioAnaliticoParams: query,
        isLoading,
        isFetching
    };
}

export function useGetGraficoRelatorios() {
    const queryParams = useRelatorioContext((s) => s.queryParams);
    const setQueryParams = useRelatorioContext((s) => s.setQueryParams);
    const unidadeId = useFilters((s) => s.filters.unidade?.id);
    const safraPeriodo = useFilters((s) => s.filters.filtersAdvanced?.safraPeriodo);

    const query = useMemo(
        () => ({
            ...queryParams,
            UnidadeId: unidadeId,
            SafraPeriodoId: safraPeriodo,
        }),
        [queryParams, unidadeId, safraPeriodo]
    );

    const { data: listTalhoes, isLoading, isFetching } = useRelatorioGraficoList(query);

    return {
        listRelatoriosGraficos: listTalhoes,
        setQueryParams,
        relatorioGraficoParams: query,
        isLoading,
        isFetching
    };
}